<ion-page>
  <ion-content class="fade-slide-enter">
    <div class="auth-shell">
      <div class="logo">{{ 'app.title' | t }}</div>
      <div class="card glass-card">
        <h1>{{ 'auth.login.title' | t }}</h1>
        <p class="subtitle">{{ 'auth.login.subtitle' | t }}</p>
        <form [formGroup]="form" (ngSubmit)="submit()">
          <ion-item lines="none" class="glass-item">
            <ion-input type="email" [label]="'auth.login.email' | t" labelPlacement="floating" formControlName="email"></ion-input>
          </ion-item>
          <ion-item lines="none" class="glass-item">
            <ion-input type="password" [label]="'auth.login.password' | t" labelPlacement="floating" formControlName="password"></ion-input>
          </ion-item>
          <div class="error" *ngIf="error">{{ error }}</div>
          <ion-button expand="block" class="futuristic-button" [disabled]="loading" type="submit">
            {{ 'auth.login.submit' | t }}
          </ion-button>
        </form>
        <div class="switch">
          {{ 'auth.login.switch' | t }} <a routerLink="/auth/register">{{ 'auth.login.switch.link' | t }}</a>
        </div>
      </div>
    </div>
  </ion-content>
</ion-page>
